import { View } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

export const PriceAndCaloriesWrapper = View.withConfig({
  flexDirection: 'row',
  alignItems: 'center',
  flexWrap: 'nowrap',
});

export const Price = withTypography({ variant: 'copyTwo', bold: true });
